import React, { Component, Fragment } from 'react';
import { withFormik, Field } from 'formik';
import { Grid, Form, Button } from 'semantic-ui-react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withLocalize } from 'react-localize-redux';
import axios from 'axios';
import { pick, map, get } from 'lodash';
import { withRouter } from 'react-router-dom';

// import validationSchema from './validators';
import { HHAlert } from '../common/util';
import { ALERT_TYPE } from '../common/constant';
import { HHUrl, HHInput, HHSingleSelect, HHRadioGroup, HHList } from './fields';
import ErrorMessage from './fields/errorMessage';
import { xinshiProfileFormValidator } from './validators';
import { signInQRCode } from '../actions';
import {
  USER_PROFILE_UPDATE,
  USER_SNS_UPDATE,
  HHSERVICES_XINSHIBEI_CREATE_PROFILE
} from '../network/api';

const socialMedia = [
  'behance',
  'dribbble',
  'facebook',
  'flickr',
  'github',
  'instagram',
  'linkedin',
  'pinterest',
  'twitter',
  'vimeo',
  'youtube',
  'weibo',
  'wechat',
  'huaban',
  'zcool',
  'douban'
];

const SocialMediaField = ({
  field,
  form: { touched, errors }
}) => {
  const hasError = !!(touched[field.name] && errors[field.name]);
  return (
    <Fragment>
      <Grid columns={2} doubling stackable>
        <Grid.Row>
          { map(socialMedia, socialMedium => (
            <Grid.Column key={socialMedium} style={{ marginBottom: '10px' }}>
              <Field
                name={`${field.name}.${socialMedium}`}
                component={HHInput}
                otherProps={{ placeholder: socialMedium }}
              />
            </Grid.Column>
          )) }
        </Grid.Row>
      </Grid>
      {hasError && (<ErrorMessage error={errors[field.name]} />)}
    </Fragment>
  );
};

const formikEnhancer = withFormik({
  validationSchema: xinshiProfileFormValidator,
  mapPropsToValues: () => ({
    name: '',
    position: 'student',
    college: '',
    companyName: '',
    major: '',
    role: '设计师',
    awards: [''],
    patents: [''],
    socialMedia: {
      behance: '',
      dribbble: '',
      facebook: '',
      flickr: '',
      github: '',
      instagram: '',
      linkedin: '',
      pinterest: '',
      twitter: '',
      vimeo: '',
      youtube: '',
      weibo: '',
      wechat: '',
      huaban: '',
      zcool: '',
      douban: ''
    },
    websiteUrl: ''
  }),
  handleSubmit: async (values, { setSubmitting, props }) => {
    const countryDialCode = get(props.user, 'profile.basicInfo.countryDialCode');
    const phoneNumber = get(props.user, 'profile.basicInfo.phone');
    let nationality = 'Chinese';

    if (countryDialCode) {
      switch (countryDialCode) {
        case 1:
          nationality = 'North American';
          break;
        case 65:
          nationality = 'Singaporean';
          break;
        case 81:
          nationality = 'Japanese';
          break;
        case 82:
          nationality = 'Korean';
          break;
        case 852:
          nationality = 'Hong Kong';
          break;
        case 853:
          nationality = 'Macau';
          break;
        case 886:
          nationality = 'Taiwanese';
          break;
        case 86:
        default:
          nationality = 'Chinese';
      }
    }

    const verifiedValues = await xinshiProfileFormValidator.validate(values);
    const { userId, token, email } = props.xinshiUser;
    const { match } = props;
    const { eventSlug } = match.params;
    const djangoProfile = axios.post(USER_PROFILE_UPDATE,
      {
        token,
        ...pick(verifiedValues, [
          'name', 'college', 'companyName', 'major', 'websiteUrl'
        ])
      }
    );
    const djangoSocialM = axios.post(USER_SNS_UPDATE,
      {
        token,
        ...verifiedValues.socialMedia
      }
    );
    const xinshiProfile = axios.post(HHSERVICES_XINSHIBEI_CREATE_PROFILE, {
      userId,
      email,
      eventSlug,
      countryDialCode,
      phoneNumber,
      nationality,
      ...verifiedValues
    });

    Promise.all([djangoProfile, djangoSocialM, xinshiProfile]).then(() => {
      HHAlert({ id: 'alert.success.xinshiSuccessSubmitProfile' }, ALERT_TYPE.SUCCESS);
      props.signInQRCode(token, () => {
        props.history.push('/profile');
      });
    }).catch(() => {
      setSubmitting(false);
    });
  }
});

class ProfileForm extends Component {
  state = {}

  render() {
    const {
      translate, handleSubmit, isSubmitting, values
    } = this.props;

    const roleOptions = [
      { label: translate('form.label.designer'), value: '设计师' },
      { label: translate('form.label.productManager'), value: '产品经理' },
      { label: translate('form.label.businessManager'), value: '商业策划' },
      { label: translate('form.label.engineer'), value: '工程师' }
    ];

    return (
      <Form onSubmit={handleSubmit}>
        <Form.Field>
          <label htmlFor='name'>{translate('form.label.name')}</label>
          <Field
            name='name'
            component={HHInput}
            otherProps={{
              id: 'name',
              placeholder: translate('form.placeholder.name')
            }}
          />
        </Form.Field>
        <Form.Field>
          <Field
            name='position'
            component={HHRadioGroup}
            otherProps={{
              items: [
                { label: translate('form.label.student'), value: 'student' },
                { label: translate('form.label.employee'), value: 'employee' }
              ],
              radioGroupName: 'position-type'
            }}
          />
        </Form.Field>

        <label>{translate('form.label.schoolCompany')}</label>
        { values.position === 'student' && (
          <Form.Field>
            <Field
              name='college'
              component={HHInput}
              otherProps={{ placeholder: translate('form.placeholder.schoolCompany') }}
            />
          </Form.Field>
        ) }
        { values.position === 'employee' && (
          <Form.Field>
            <Field
              name='companyName'
              component={HHInput}
              otherProps={{ placeholder: translate('form.placeholder.schoolCompany') }}
            />
          </Form.Field>
        ) }

        <Form.Field>
          <label htmlFor='major'>{translate('form.label.major')}</label>
          <Field
            name='major'
            component={HHInput}
            otherProps={{
              id: 'major',
              placeholder: translate('form.placeholder.major')
            }}
          />
        </Form.Field>

        <Form.Field>
          <label htmlFor='role'>{translate('form.label.role')}</label>
          <Field
            name='role'
            component={HHSingleSelect}
            otherProps={{
              id: 'role',
              placeholder: translate('form.placeholder.role'),
              options: roleOptions,
              simpleValue: true,
              searchable: false,
              clearable: false
            }}
          />
        </Form.Field>

        <Form.Field>
          <label htmlFor='awards'>{translate('form.label.awards')}</label>
          <Field
            name='awards'
            component={HHList}
            otherProps={{
              deleteComponent: <Button fluid type='button' color='red'>{translate('button.delete')}</Button>,
              addComponent: (
                <Button
                  basic color='green' fluid
                  type='button' className='addNew'
                > +
                </Button>
              )
            }}
          />
        </Form.Field>

        <Form.Field>
          <label htmlFor='patents'>{translate('form.label.patents')}</label>
          <Field
            name='patents'
            component={HHList}
            otherProps={{
              deleteComponent: <Button fluid type='button' color='red'>{translate('button.delete')}</Button>,
              addComponent: (
                <Button
                  basic color='green' fluid
                  type='button' className='addNew'
                > +
                </Button>
              )
            }}
          />
        </Form.Field>

        <Form.Field>
          <label htmlFor='websiteUrl'>{translate('form.label.socialMedia')}</label>
          <Field
            name='socialMedia'
            component={SocialMediaField}
            otherProps={{
              deleteComponent: <Button fluid type='button'>{translate('button.delete')}</Button>
            }}
          />
        </Form.Field>

        <Form.Field>
          <label htmlFor='websiteUrl'>{translate('form.label.personalWebsite')}</label>
          <Field
            name='websiteUrl'
            component={HHUrl}
            otherProps={{
              id: 'websitelink',
              icon: 'linkify',
              placeholder: 'event.hackhub.com',
              type: 'text'
            }}
          />
        </Form.Field>

        <Button
          disabled={isSubmitting}
          loading={isSubmitting}
          fluid
          primary
        >
          {translate('button.submit')}
        </Button>
      </Form>
    );
  }
}

export default compose(
  withLocalize,
  withRouter,
  connect(
    ({ user, xinshiUser }) => ({ user, xinshiUser }),
    { signInQRCode }
  ),
  formikEnhancer,
)(ProfileForm);



// WEBPACK FOOTER //
// ./src/components/forms/xinshiProfileForm.js